import API from '../';
import store from 'src/redux/store';
import { HTTP_METHODS } from '../helpers/methods-helpers';
import notice from 'src/common/components/Notice';

class SessionsAPI extends API {
	postValidateFile(file) {
		const dataString = JSON.stringify(file);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/validar/precarga`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	postUploadFile(file) {
		const dataString = JSON.stringify(file);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/precarga`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getPreviousSessionsByOrgan(organ) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/anteriores/${organ}?omitirFecha=true`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getPreviousSessionsByOrganYear(organ, year, month) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/anteriores/${organ}?anio=${year}&mes=${month}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getUpcomingSessionsByOrgan(organ) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/proximas/${organ}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	postSesion(sesion) {
		const dataString = JSON.stringify(sesion);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	putSesion(sesion) {
		const dataString = JSON.stringify(sesion);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/put/${sesion.id}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getFilterSessions(
		organ,
		sessionNumber,
		startSessionDate,
		endSessionDate,
		pagination,
		currentPage
	) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/getSesiones?organo=${organ}&numero_sesion=${sessionNumber}&fechaInicio=${startSessionDate}&fechaFin=${endSessionDate}&registrosPorPagina=${pagination}&numeroDePagina=${currentPage}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getByOrgan(organ) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/getSesiones?organo=${organ}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getByDate(organ, startSessionDate, endSessionDate) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/getSesiones?organo=${organ}&fechaInicio=${startSessionDate}&fechaFin=${endSessionDate}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getSesionsByDate(startSessionDate, endSessionDate) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/get?fechaInicio=${startSessionDate}&fechaFin=${endSessionDate}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getBySession(sessionNumber) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/${sessionNumber}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	postSession(idSession, body, filial) {
		const dataString = JSON.stringify(body);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/publicar/${idSession}${
					filial !== null ? filial : ''
				}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	deleteSession(idSession) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/publicar/${idSession}?estatus=E`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	removalApproval(idSession, approval) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/publicar/${idSession}?estatus=E&${approval}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	postAnnouncement(idSession, body, filial) {
		const dataString = JSON.stringify(body);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/publicar_convocatoria/${idSession}${
					filial !== null ? filial : ''
				}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	generateAnnouncement(idSession, place, notice, direction) {
		const host = process.env.REACT_APP_API_URL;
		const token = store.getState()?.auth?.user?.accessToken;

		return fetch(
			`${host}${this.scheme}/download_orden_dia/${idSession}?lugar=${place}&aviso=${notice}&direccion=${direction}`,
			{
				method: HTTP_METHODS.post_M,
				responseType: 'blob',
				dataType: 'binary',
				body: JSON.stringify({
					token: token,
				}),
			}
		)
			.then(function (resp) {
				return resp.blob();
			})
			.catch((e) => {
				return 3;
			});
	}
	downloadElectronicFolder(idSession) {
		const host = process.env.REACT_APP_API_URL;
		const token = store.getState()?.auth?.user?.accessToken;

		let raw = JSON.stringify({
			token: token,
		});

		return fetch(`${host}${this.scheme}/descargar_carpeta_electronica/${idSession}`, {
			method: HTTP_METHODS.post_M,
			responseType: 'blob',
			dataType: 'binary',
			//headers: header,
			body: raw,
		})
			.then(function (resp) {
				return resp.blob();
			})
			.catch((e) => {
				return 3;
			});
	}
	generateGuie(idSession, tipeGuie, tipeFile) {
		const host = process.env.REACT_APP_API_URL;
		let myHeaders = new Headers();
		const token = store.getState()?.auth?.user?.accessToken;
		myHeaders.append('Content-Type', 'text/plain');
		//myHeaders.append('Authorization', `Bearer ${token}`);
		let raw = JSON.stringify({
			sesionId: idSession,
			tipoGuia: tipeGuie,
			tipoAchivo: tipeFile,
			token: token,
		});

		let requestOptions = {
			method: HTTP_METHODS.post_M,
			headers: myHeaders,
			body: raw,
			redirect: 'follow',
		};

		return fetch(`${host}/guias/generar-documento`, requestOptions)
			.then((response) => response.text())

			.then(function (result) {
				return result;
			})
			.catch(() => notice('Ha ocurrido un error', 'error'));
	}

	postNotifyChanges(idSession, body) {
		const dataString = JSON.stringify(body);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/notificar_cambios/${idSession}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	getFilesFolder(idSession, body) {
		const dataString = JSON.stringify(body);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/obtener_archivos/${idSession}`,
				data: dataString,
				method: HTTP_METHODS.post_M,
			})
		);
	}

	// getZipBack(idSession, body) {
	// 	const dataString = JSON.stringify(body);
	// 	return this.requestWrapper(
	// 		this.request({
	// 			url: `${this.scheme}/obtener_carpeta_zip/${idSession}`,
	// 			data: dataString,
	// 			method: 'POST',
	// 			responseType: 'blob',
	// 			dataType: 'binary',
	// 		})
	// 	);
	// }

	getNextSessionByUser(idUser) {
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/sesiones_proximas/${idUser}`,
				method: HTTP_METHODS.post_M,
			})
		);
	}
	getSessionExisting(body) {
		const dataString = JSON.stringify(body);
		return this.requestWrapper(
			this.request({
				url: `${this.scheme}/guardar_publicacion/`,
				method: HTTP_METHODS.post_M,
				data: dataString,
			})
		);
	}
}

export const sessionsAPI = new SessionsAPI('/sesiones');
